import * as React from 'react';
import { MapContext } from '../Map';
import { NavigateType } from '../../types';

const { useEffect, useContext, useState } = React;

export interface Props {
  path: AMap.LocationValue[];
  type: NavigateType;
  navigateOptions?: { [key: string]: any };
  onComplete?: (res: any) => any;
}

function Navigate(props: Props) {
  const { path, type, navigateOptions } = props;
  const map = useContext(MapContext);
  const [drivingEntity, setDrivingEntity]: [any, any] = useState(null);

  useEffect(() => {
    if (!map || !path ) {
      return;
    }

    if (drivingEntity) {
      drivingEntity.clear();
    }

    const type2Plugin: { [key: string]: any } = {
      Driving: 'AMap.Driving',
      Transfer: 'AMap.Transfer',
      Walking: 'AMap.Walking',
      Riding: 'AMap.Riding',
      TruckDriving: 'AMap.TruckDriving',
    }

    let driving: any = null;

    AMap.plugin([type2Plugin[type]], function() {
      driving = new (AMap as any)[type]({
        // policy: (AMap as any).DrivingPolicy.LEAST_TIME,
        map: map,
        ...navigateOptions,
      });
      setDrivingEntity(driving);

      let points: any = path;

      const searchCallback = (status: any, result: any) => {
        if (status === 'complete') {
          console.log('绘制路线完成', result);
          if (props.onComplete) {
            props.onComplete({
              isSuccess: true,
              ...result,
            });
          }
        } else {
          console.log('获取规划数据失败：' + status)
          if (props.onComplete) {
            props.onComplete({
              isSuccess: false,
            });
          }
        }
      }

      if (type === 'TruckDriving') {
        if (!navigateOptions || !navigateOptions.size) {
          console.log('error，TruckDriving navigateOptions.size is null');
          return;
        }
        points = path.map((item) => ({
          lnglat: item,
        }));
        driving.search(points, searchCallback);
      } else {
        driving.search(...points, searchCallback);
      }
    })

    return () => {
      if(map&& driving){
        driving.clear();
      }
    }
  }, [map, path, type]);

  return null;
}

export default Navigate;
